import { categories, events } from "@/mocks/events";
import { news } from "@/mocks/news";
import useMockLoading from "@/hooks/useMockLoading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import TodayEvents from "@/pages/home/components/TodayEvents";
import ResultsBoard from "@/pages/home/components/ResultsBoard";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import NewsZone from "@/pages/home/components/NewsZone";
import SiteIntro from "@/pages/home/components/SiteIntro";

const TODAY = "2026-10-15";

export default function Home() {
  const loading = useMockLoading(600);

  const slides = events.filter((e) => e.featured);
  const todayEvents = events.filter((e) => e.date === TODAY);
  const results = [...events]
    .filter((e) => e.status === "finished")
    .sort((a, b) => (a.date < b.date ? 1 : -1));
  const categoryItems = categories.map((category) => ({
    category,
    count: events.filter((e) => e.categoryId === category.id).length,
  }));
  const sortedNews = [...news].sort((a, b) => (a.date < b.date ? 1 : -1));

  return (
    <div className="w-full">
      <HeroCarousel slides={slides} />
      <div className="animate-fade-up">
        <TodayEvents events={todayEvents} loading={loading} />
      </div>
      <ResultsBoard events={results} />
      <CategoryGrid items={categoryItems} />
      <NewsZone news={sortedNews} loading={loading} />
      <SiteIntro />
    </div>
  );
}